import {
  API_CALL,
  RECEIVE_CONST,
  REQUEST_CONST,
  CONST_FAILED
} from "./types";

export const getConstants = () => ({
  type: API_CALL,
  onRequest: REQUEST_CONST,
  onResponse: RECEIVE_CONST,
  onError: CONST_FAILED,
  responseKey: 'constants',
  payload: {
    method: 'GET',
    url: '/const'
  }
});
